import { Component } from 'solid-js'
import { userStore } from '../../../store/user'
import SimpleModal from '../SimpleModal'

export const NoTokensModal: Component = () => {
  const state = userStore()

  // #212: on the main CosplayFans app the out-of-tokens state now renders through the
  // Buy Tokens modal's "You're Running On Empty" variant (BuyTokens.tsx), which is
  // gated to NON-hentai paths. This plain fallback stays only for hentai landing paths
  // (where that modal is suppressed) so we never show two popups at once.
  const isHentaiPath = () =>
    window.location.pathname.startsWith('/hentai') ||
    window.location.pathname.startsWith('/lp/hentai')

  return (
    <SimpleModal
      show={state.showNoTokensModal && isHentaiPath()}
      onClose={() => userStore.showNoTokensModal(false)}
    >
      <div class="relative mx-auto flex max-w-md flex-col items-center justify-center rounded-2xl bg-gradient-to-tr from-purple-600 to-blue-600 p-6 shadow-2xl">
        {/* Info Icon */}
        <div class="absolute left-5 top-2 flex items-center">
          <span class="text-xl">ⓘ</span>
        </div>
        {/* Close Button */}
        <button
          class="absolute right-4 top-1 text-4xl text-white hover:opacity-70"
          onClick={() => userStore.showNoTokensModal(false)}
          aria-label="Close"
        >
          ×
        </button>
        {/* Message */}
        <div class="mb-4 mt-5 text-left text-lg leading-snug">
          Uh-oh! Looks like you're out of tokens&nbsp; but don't worry, you're just a step away from
          getting back to the fun!
        </div>
        {/* Add Tokens Button */}
        <button
          class="w-full rounded-xl border border-white bg-transparent py-3 text-xl font-bold text-white transition hover:bg-white hover:text-[#a259ff]"
          onClick={() => {
            userStore.showNoTokensModal(false)
            userStore.buyTokensModal(true)
          }}
        >
          Add Tokens
        </button>
      </div>
    </SimpleModal>
  )
}
